/**
 * Vue I18n pipe-index rules matching the shapes produced by
 * `@booksy-com/node-tools` import-messages-2 transformers.
 *
 * English-like (2 choices = legacy `one | other`, 3 choices = `other | one | other`):
 * - n = 0 → other
 * - n = 1 → one
 * - n ≥ 2 → other
 *
 * Slavic (3 choices = legacy `one | few | many`, 4 choices = `many | one | few | many`):
 * - n = 0 → many
 * - n = 1, 21, 31… → one
 * - n = 2–4, 22–24… → few
 * - otherwise → many
 */

export function pluralizationEN (choice: number, choicesLength: number): number {
  const n = Math.abs(choice)

  if (choicesLength === 2) {
    return n === 1 ? 0 : 1
  }

  if (n === 0) return 0
  if (n === 1) return 1
  return 2
}

export function pluralizationPT (choice: number, choicesLength: number): number {
  return pluralizationEN(choice, choicesLength)
}

export function pluralizationES (choice: number, choicesLength: number): number {
  return pluralizationEN(choice, choicesLength)
}

export function pluralizationPL (choice: number, choicesLength: number): number {
  return slavicPluralRule(choice, choicesLength)
}

export function pluralizationUK (choice: number, choicesLength: number): number {
  return slavicPluralRule(choice, choicesLength)
}

function slavicPluralRule (choice: number, choicesLength: number): number {
  const n = Math.abs(choice)
  const teen = n > 10 && n < 20
  const endsWithOne = n % 10 === 1
  const isFew = !teen && n % 10 >= 2 && n % 10 <= 4

  if (choicesLength >= 4) {
    if (n === 0) return 0
    if (!teen && endsWithOne) return 1
    if (isFew) return 2
    return 3
  }

  if (n === 0) return 2
  if (!teen && endsWithOne) return 0
  if (isFew) return 1
  return 2
}
